require('./aresLoanInformation.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
// @ helpers
const { formatText, getLanguage } = require('core/i18n').i18n;
const { toFirstUppercase } = require('utilities/stringHelper');
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
// @ commons
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
// @components
const LoanCollectiveTooltip = require('../../loanCollectiveTooltip/loanCollectiveTooltip');
const LoanCollectiveTag = require('../../loanCollectiveTag/loanCollectiveTag');
//@constants
const { API_ENTERPRISE_NUMBER, API_CENTER, PERCENTAGE_SYMBOL } = require('constants/index');
const {
    LOANS_MORTGAGES_PAYROLL_LOAN,
    LOAN_FOUR_LAST_CHARACTERS
} = require('../../../../loansConstants/index');


class ARESLoanInformation extends React.Component {

    buildInterveners() {
        const intervenersList = this.props.immLoan.getIn(['interveners', 'interveners']);
        let content = intervenersList.map((intervener, index) => {
            const intervenerKey = `loan-information-intervener-${index}`;
            const intervenerTitle = toFirstUppercase(intervener.get('intervenerType'));
            return (
                <OKInformativeListItem
                    key={intervenerKey}
                    title={intervenerTitle}
                    bodyText={intervener.get('intervenerName')}
                />
            );
        }).toArray();

        return (
            <OKInformativeList title="loan-interveners" columns={2}>
                {content}
            </OKInformativeList>
        );
    }

    formatInterest(interest) {
        return interest
            .toString()
            .replace(/\./, ',')
            .concat(' ', PERCENTAGE_SYMBOL);
    }

    buildBadge() {
        const { immLoan, toolTipContent } = this.props;
        const type = immLoan.get('type');
        const isPayroll = type === LOANS_MORTGAGES_PAYROLL_LOAN;
        const tooltip = isPayroll ? <LoanCollectiveTooltip /> : toolTipContent;

        return (
            <LoanCollectiveTag
                extraClass="loan-information__collective-tag"
                immLoan={immLoan}
                tooltipContent={tooltip}
            />
        )
    }

    render() {
        const { immLoan, accountAlias } = this.props;
        const immGeneralData = immLoan.get('generalData');
        const initialCapital = immGeneralData.get('initialCapital');
        const expirationDate = immGeneralData.get('currentExpirationDate');
        const openingDate = immGeneralData.get('openingDate');
        const associatedAccount = immLoan.get('account') || '';
        const trimAssociatedAccount = associatedAccount.trim();
        const formattedAssociatedAccount = `${accountAlias} ****${trimAssociatedAccount.substring(trimAssociatedAccount.length - LOAN_FOUR_LAST_CHARACTERS)}`;
        const loanContract = `${API_ENTERPRISE_NUMBER} ${API_CENTER} ${immLoan.get('newProduct')} ${immLoan.get('newContractNumber')}`;
        const typeOfInterest = this.formatInterest(immGeneralData.get('interestType'));
        const interestMode = immGeneralData.get('interestMode');
        const intervenersList = this.buildInterveners();
        const sectionTitle = immLoan.get('isMortgage') ? formatText('loan-mortgageInformation') : formatText('loan-loanInformation');
        const plainAmountObject = getPlainAmountObject(initialCapital);
        const badge = this.buildBadge();

        return (
            <OKSectionBox title={sectionTitle}>
                <article className="ares-loan-information">
                    {badge}
                    <section className="loan-information__body">
                        <OKInformativeList columns={2}>
                            <OKInformativeListItem title={formatText('loan-initialCapital')}>
                                <OneLineSymbolAmount
                                    className="loan-information__initial-capital"
                                    amountObject={plainAmountObject}
                                    language={getLanguage()}
                                    amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
                            </OKInformativeListItem>
                            <OKInformativeListItem
                                title={formatText('loan-dueDate')}
                                bodyText={expirationDate}
                            />
                            <OKInformativeListItem
                                title={formatText('loan-openingDate')}
                                bodyText={openingDate}
                            />
                            <OKInformativeListItem
                                title={formatText('loan-associatedAccount')}
                                bodyText={formattedAssociatedAccount}
                            />
                            <OKInformativeListItem
                                title={formatText('loan-loanContract')}
                                bodyText={loanContract}
                            />
                            <OKInformativeListItem
                                title={formatText('loan-typeOfInterest')}
                                bodyText={typeOfInterest}
                            />
                        </OKInformativeList>
                        <OKInformativeList columns={1}>
                            <OKInformativeListItem
                                title={formatText('loan-interestMode')}
                                bodyText={interestMode}
                            />
                        </OKInformativeList>
                        {intervenersList}
                    </section>
                </article>
            </OKSectionBox>
        );
    }
}

ARESLoanInformation.propTypes = {
    immLoan: PropTypes.object.isRequired,
    accountAlias: PropTypes.string.isRequired,
    toolTipContent: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.string
    ])
};

module.exports = ARESLoanInformation;
